import { trackOnramperSuccess } from '@/app/providers/mixpanel/EventTracker'

export default defineNuxtRouteMiddleware((to) => {
  const nuxtApp = useNuxtApp()
  const notificationStore = useSharedNotificationStore()

  const { t } = nuxtApp?.$i18n || {}

  if (to.query.onramper_status === 'success') {
    const {
      network,
      orderId,
      fiatAmount,
      cryptoAmount,
      fiatCurrency,
      walletAddress,
      partnerOrderId,
      totalFeeInFiat,
      cryptoCurrency
    } = (to.query as Record<string, string>) || {}

    notificationStore.success({
      title: t('onramper.success', {
        fiatCurrency,
        cryptoAmount,
        crypto: to.query.cryptoCurrency
      })
    })

    trackOnramperSuccess({
      network: network || '',
      orderId: orderId || '',
      fiatAmount: fiatAmount || '',
      cryptoAmount: cryptoAmount || '',
      fiatCurrency: fiatCurrency || '',
      walletAddress: walletAddress || '',
      totalFeeInFiat: totalFeeInFiat || '',
      cryptoCurrency: cryptoCurrency || '',
      partnerOrderId: partnerOrderId || ''
    })
  }
})
